<template>
  <div class="ricercaEst">
    <div class="div_ricerca">
      <div class="ricerca">
        <div class="img-ricerca">
          <img alt="ricerca" src="../assets/ricerca.png" class="imm_ricerca" />
        </div>
        <input type="text" class="ricerca_text" v-model="search" />
      </div>
    </div>
  </div>

  <div class="esterno">
    <ul class="cards">
      <div
        v-for="episodio in listaFiltrata(this.$store.getters['episodi']).reverse()"
        :key="episodio.id"
      >
        <li>
          <router-link :to="{ name: 'Episodio', params: { id: episodio.id } }">
            <a href="" class="card">
              <img
                :alt="'puntata' + episodio.id"
                :src="require('../assets/puntate/' + episodio.id + '.png')"
                class="card__image"
              />
              <div class="card__overlay-head">
                <div class="card__header">
                  <!-- <img class="card__thumb" :src="require('../assets/puntate/' + episodio.id + '.png')" alt="" /> -->
                  <div class="card__header_footer-text">
                    <h5 class="card__status">{{ episodio.title }}</h5>
                  </div>
                </div>
              </div>

              <div class="card__overlay-foot">
                <div v-if="episodio.FT != 'ND'" class="card__footer">
                  <!-- <img class="card__thumb" :src="require('../assets/puntate/' + episodio.id + '.png')" alt="" /> -->
                  <div class="card__header_footer-text">
                    <!-- <h3 class="card__title">{{ episodio.title }}</h3> -->
                    <h2 class="card__status2">FT. {{ episodio.FT }}</h2>
                  </div>
                </div>
                <p class="card__description">
                  {{ episodio.details.slice(0, 90) }}...
                </p>
              </div>
            </a>
          </router-link>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { ref, reactive, computed, watch, watchEffect } from "vue";
import { useStore } from "vuex";
export default {
  name: "Puntate",
  setup() {
    const search = ref("");
    const listaFiltrata = (lista) => {
      return lista.filter((ep) =>
        ep.title.toLowerCase().includes(search.value.toLowerCase())||ep.FT.toLowerCase().includes(search.value.toLowerCase())||ep.details.toLowerCase().includes(search.value.toLowerCase())
      );
    };
    return { search, listaFiltrata };
  },
};
</script>

<style>
:root {
  --surface-color: #2c3e50;
  --curve: 40;
}

* {
  box-sizing: border-box;
}

body {
  font-family: "Noto Sans JP", sans-serif;
  background-color: #fef8f8;
  /* border: 1.5px solid #0e51cc; */
}
.ricercaEst {
  display: flex;
  justify-content: center;
  align-items: center;
}
.div_ricerca {
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 14vh;
  width: 17%;
}
.ricerca {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2c3e50;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #ccb7a4;
  /* width: 20%; */
  padding-left: 0.5%;
  padding-right: 5%;
  padding-top: 1.5%;
  padding-bottom: 1.5%;
  width: 100%;
}
.imm_ricerca {
  --max-height: 50px;
  /* Set a baseline width for your element */
  width: 95%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 50px) * var(--img-ratio, 1));
}
.ricerca_text {
  width: 95%;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 2rem 3vw;
  padding: 0;
  list-style-type: none;
  justify-items: center;
  margin-top: 15%;
  /* align-content: center; */
  /* border: 1.5px solid #0ecc4d; */
}

.card {
  position: relative;
  display: block;
  height: 100%;
  border-radius: calc(var(--curve) * 1px);
  overflow: hidden;
  text-decoration: none;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 5px;
  /* border: 1.5px solid #0ecc27; */
  align-items: center;
  max-width: calc(var(--max-height, 300px) * var(--img-ratio, 1));
}

.card__image {
  width: 100%;
  height: auto;
}

.card__overlay-head {
  position: absolute;
  top: 0;
  z-index: 1;
  border-radius: calc(var(--curve) * 1px);
  background-color: var(--surface-color);
  transform: translateY(-200%);
  transition: 0.2s ease-in-out;
  align-items: center;
  width: 95%;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px;
}

.card:hover {
  box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 20px;
}

.card__header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2em;
  padding: 2%;
  border-radius: calc(var(--curve) * 1px);
  /* border-top-left-radius: 0;
  border-top-right-radius: 0; */
  background-color: var(--surface-color);
  transform: translateY(0%);
  transition: 0.2s ease-in-out;
  /* border: 1.5px solid #0ecc4d; */
}

.card:hover .card__overlay-head {
  transform: translateY(20%);
  /* border-bottom-left-radius: 0;
  border-bottom-right-radius: 0; */
}

.card:hover .card__header {
  transform: translateY(0%);
}

.card__header_footer-text {
  /* padding: 0; */
  padding: auto;
  margin: auto;
  margin-bottom: 0;
  width: 95%;
  /* border: 1.5px solid #b60ecc; */
}

.card__overlay-foot {
  position: absolute;
  bottom: 0;
  z-index: 1;
  border-radius: calc(var(--curve) * 1px);
  background-color: var(--surface-color);
  transform: translateY(200%);
  transition: 0.2s ease-in-out;
  /* border: 1.5px solid #b60ecc; */
  align-items: center;
  width: 95%;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px;
}

.card:hover .card__overlay-foot {
  transform: translateY(-5%);
}

.card:hover .card__footer {
  transform: translateY(0);
}

.card__footer {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2em;
  padding: 2%;
  border-radius: calc(var(--curve) * 1px);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: var(--surface-color);
  transform: translateY(-200%);
  transition: 0.2s ease-in-out;
}

.card__arc {
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: 100%;
  right: 0;
  z-index: 1;
  /* border: 1.5px solid #0e51cc; */
}

.card__arc path {
  fill: var(--surface-color);
  /* d: path("M 40 80 c 22 0 40 -22 40 -40 v 40 Z"); */
}

.card__thumb {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.card__title {
  font-size: 1.2em;
  margin-top: 0.2em;
  color: white;
  text-align: center;
  /* border: 1.5px solid #0e51cc; */
}

.card__tagline {
  display: block;
  margin: 1em 0;
  font-family: "MockFlowFont";
  font-size: 0.8em;
  color: white;
  /* border: 1.5px solid #0e51cc;  */
}

.card__status {
  font-size: 1em;
  color: white;
  padding: auto;
  padding: 2%;
  margin: auto;
  /* border: 1.5px solid #0e51cc; */
}

.card__status2 {
  font-size: 1em;
  color: white;
  padding-top: 1%;
  padding-bottom: 1%;
  /* border: 1.5px solid #0e51cc; */
}

.card__description {
  padding-top: 1%;
  padding-bottom: 2%;
  padding-left: 1em;
  padding-right: 1em;
  /* margin: 0; */
  color: white;
  font-family: "MockFlowFont";
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  /* border: 1.5px solid #0e51cc; */
}

@media screen and (min-width: 1100px) and (max-width: 1500px) {
  .div_ricerca {
    top: 11vh;
    width: 17%;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1100px) {
  .div_ricerca {
    top: 9vh;
    width: 17%;
  }
}
@media screen and (min-width: 850px) and (max-width: 1000px) {
  .div_ricerca {
    top: 15vh;
    width: 23%;
  }
  .ricerca {
    padding-left: 1.5%;
    padding-right: 5%;
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media screen and (max-width: 850px) and (min-width: 540px) {
  .div_ricerca {
    top: 15vh;
    width: 33%;
  }
  .ricerca {
    padding-left: 1.5%;
    padding-right: 5%;
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media screen and (max-width: 540px) and (min-width: 380px){
  .div_ricerca {
    top: 20vh;
    width: 83%;
  }
  .ricerca {
    width: 70%;
    padding-left: 1.5%;
    padding-right: 3%;
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media screen and (max-width: 380px) {
    .div_ricerca {
    top: 25vh;
    width: 83%;
  }
    .ricerca {
    width: 70%;
    padding-left: 1.5%;
    padding-right: 3%;
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
</style>